import { Button, ButtonBase, styled } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';

function EmailTemplateSettings() {
  const auth = useAuth();

  const [
    isEditing,
    setIsEditing,
  ] = useState(false);
  const [
    taxAgentNumber,
    setTaxAgentNumber,
  ] = useState('123 456 789');

  const [
    emailSent,
    setEmailSent,
  ] = useState(false);

  const TextButton = styled(Button)(({ theme }) => ({
    color: 'white',
    textTransform: 'none',
    padding: '0vw 0vw',
  }));

  function sendEmailHandler() {
    // openLoading("Sending email ...")
    fetch(`${window.origin}/api/sendemail`, {
      headers: {
        Authorization: `Bearer ${auth.user?.access_token}`,
      },
    }).then(response => response.status,
    ).then((status) => {
      console.log(status);
    });
    setEmailSent(true);
  }

  function naviagteATOPortal() {
    window.open('https://www.ato.gov.au/General/Online-services/Access-Manager/About-Access-Manager/#LogintoAccessManager', '_blank');
  }

  useEffect(() => {
    fetch(`${window.origin}/api/tan`, {
      headers: {
        Authorization: `Bearer ${auth.user?.access_token}`,
      },
    }).then(response => response.json(),
    ).then((data) => {
      setTaxAgentNumber(data[0].tan);
    });
  }, []);

  return (
    <div>

      <p style={{ fontSize: '0.8vw', color: 'rgb(0, 15, 30, 0.6)', fontWeight: '300', textAlign: 'center', marginBottom: '2vw' }}>
        Configure email template to send to your clients
      </p>

      <div style={{ padding: '0 2.5vw', display: 'flex', height: '50vh', justifyContent: 'center', alignItems: 'center' }}>
        <div style={{ flex: 1, color: 'rgb(0, 0, 0, 0.4)', textAlign: 'center' }}>
          <p style={{ margin: 0, fontSize: '0.9vw' }}>This feature is currently under development and will be available soon</p>
        </div>
      </div>
    </div>
  );
}

export default EmailTemplateSettings;
